var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 78,
    viewBox: "0 0 63 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4126_48640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3408 78C28.6089 78 23.2663 77.0175 18.3128 75.0526C13.4302 73.0175 9.32588 70.1754 6 66.5263L15.3408 57.8947C18.1713 60.9123 20.9665 63.0175 23.7263 64.2105C26.5568 65.3333 30.0242 65.8947 34.1285 65.8947C37.1006 65.8947 39.6834 65.4737 41.8771 64.6316C44.1415 63.7193 45.8752 62.4561 47.0782 60.8421C48.352 59.2281 48.9888 57.3684 48.9888 55.2632C48.9888 53.2982 48.4935 51.614 47.5028 50.2105C46.5121 48.807 45.1676 47.7193 43.4693 46.9474C41.771 46.1053 39.7542 45.6842 37.419 45.6842H28.0782V34.3158H36.1453C39.4711 34.3158 42.0894 33.4737 44 31.7895C45.9106 30.0351 46.8659 27.6491 46.8659 24.6316C46.8659 22.6667 46.2998 20.9123 45.1676 19.3684C44.0354 17.7544 42.4786 16.4912 40.4972 15.5789C38.5866 14.6667 36.3929 14.2105 33.9162 14.2105C30.2365 14.2105 27.0521 14.8421 24.3631 16.1053C21.7449 17.3684 18.9851 19.614 16.0838 22.8421L6.63687 14.2105C10.1043 10.3509 14.2439 7.36842 19.0559 5.26316C23.9385 3.08772 29.0689 2 34.4469 2C39.6127 2 44.1769 2.91228 48.1397 4.73684C52.1024 6.49123 55.216 8.94737 57.4804 12.1053C59.7449 15.2632 60.8771 18.8772 60.8771 22.9474C60.8771 26.8772 59.568 30.386 56.9497 33.4737C54.3315 36.4912 50.9348 38.5965 46.7598 39.7895C51.7132 40.7719 55.6406 42.7368 58.5419 45.6842C61.514 48.6316 63 52.1754 63 56.3158C63 60.4561 61.7616 64.1754 59.2849 67.4737C56.8082 70.7719 53.4115 73.3684 49.095 75.2632C44.8492 77.0877 39.9311 78 34.3408 78Z",
    fill: "hsla(200, 53%, 23%, 0.5)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4126_48640",
    x: 0,
    y: 0,
    width: 63,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -6,
    dy: -2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.913725 0 0 0 0 0.913725 0 0 0 0 0.972549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4126_48640"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4126_48640",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree);
export default __webpack_public_path__ + "static/media/three.b1f5c6d4a9363d6045701480474e92c6.svg";
export { ForwardRef as ReactComponent };